module.exports = __webpack_public_path__ + "static/img/live_type03.7bd26ba8.png";